<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5 v-show="!isModal">Edit Anggota</h5>
      </template>

      <b-form @submit.prevent="openModalConfirm(requiredForDataKerabatAndPihakLain)">
        <b-alert show variant="info" class="mb-3">
          Untuk pengubahan <strong>nama</strong> atau <strong>nomor handphone</strong> nasabah,
          silakan gunakan tombol <strong>Edit</strong> pada {{ isModal ? 'detail nasabah' : 'Master > Anggota' }}
          (<strong>Nama / No. HP</strong>) di halaman sebelumnya.
        </b-alert>

        <DataIdentitas
          :dataIdentitas="input.dataIdentitas"
          :dataJenisIdentitas="jenisIdentitas"
          :isEdit="true"
          @reset="resetDataIdentitas"
        />
        <!-- <DataRekening :id="id" v-if="$companyId == 'PGI'" @getEmail="getEmail" /> -->
        <DataAnggota
          :dataAnggota="input.dataAnggota"
          :isEdit="true"
          @reset="resetDataAnggota"
          @copy="copyDataIdentitas"
        />
        <DataKerabat
          :dataKerabat="input.dataKerabat"
          :vDataKerabat="$v.input.dataKerabat"
          @reset="resetDataKerabat"
        />
        <DataPihakLain
          :dataPihakLain="input.dataPihakLain"
          :vDataPihakLain="$v.input.dataPihakLain"
          @reset="resetDataPihakLain"
        />

        <DataIdentitasDiri isEdit :dataEdit="anggota" />
        <DataFoto :dataFoto="input.dataFoto" />

        <div class="form-wrapper-btn submit-btn-wrapper">
          <b-button type="submit" name="anggotaUpdateBtn" variant="pgiBtn">
            Update
          </b-button>
        </div>
      </b-form>
    </b-card>

    <ModalConfirm
      id="modal-confirm-copy"
      title="Confirm Copy Data Identitas ke Anggota"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mengisi bagian Anggota dengan data dari Identitas?"
      @submit="onCopyFields"
    />
    <ModalConfirm
      id="modal-confirm-reset"
      title="Confirm Reset Kotak Input"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk menghapus semua kotak input bagian ini?"
      @submit="onResetFields"
    />
    <ModalConfirm
      id="modal-confirm-edit"
      title="Confirm Edit Anggota"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mengubah data anggota ini?"
      @submit="onSubmit"
    />

    <!-- ===== Modal List Identitas ===== -->
    <b-modal
      id="modal-identitas-list"
      size="xl"
      title="Identitas Nasabah"
      hide-footer
      @hidden="onCloseIdentitas"
    >
      <div class="mb-3 d-flex justify-content-between">
        <div>
          {{ input.dataIdentitas.nama }} -
          <b-badge variant="primary">{{ noAnggota }}</b-badge>
        </div>
        <div>
          <b-button
            size="sm"
            variant="success"
            @click="$bvModal.show('modal-identitas-add')"
          >
            + Tambah Identitas
          </b-button>
        </div>
      </div>
      <div v-if="isLoadIdentitas">...load</div>
      <div v-else>
        <b-table
          :items="identitasList"
          :fields="[
            { key: 'jenisIdentitas', label: 'Jenis / No Identitas' },
            {
              key: 'noIdentitas',
              label: 'No Identitas',
              class: 'd-none d-sm-table-cell',
            },
            { key: 'aksi', label: 'Aksi' },
          ]"
          small
          bordered
          responsive
        >
          <!-- Gabungan utk mobile -->
          <template #cell(jenisIdentitas)="{ item }">
            <div class="d-sm-none">
              <div>
                <strong>{{ item.jenisIdentitas }}</strong>
              </div>
              <div class="text-muted">{{ item.noIdentitas }}</div>
            </div>
            <!-- Desktop tetap tampil jenis identitas -->
            <div class="d-none d-sm-block">
              {{ item.jenisIdentitas }}
            </div>
          </template>

          <template #cell(fotoIdentitas)="{ item }">
            <div class="d-flex align-items-center">
              <img
                :src="item.fotoIdentitas"
                alt="foto"
                style="
                  width: 56px;
                  height: 56px;
                  object-fit: cover;
                  border-radius: 6px;
                  border: 1px solid #eee;
                "
              />
            </div>
          </template>

          <template #cell(aksi)="{ item }">
            <div class="flex">
              <b-button
                size="sm"
                class="table-button edit mr-2"
                title="Edit"
                @click="editDataIdentitas(item)"
              >
                <i class="fa fa-pencil-square-o"></i>
              </b-button>

              <b-button
                size="sm"
                variant="pgiBtn"
                name="bayarBtn"
                @click="openPreview(item.fotoIdentitas)"
              >
                <i class="fa fa-picture-o" aria-hidden="true"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
    </b-modal>

    <!-- ===== Modal Tambah Identitas ===== -->
    <b-modal
      id="modal-identitas-add"
      title="Tambah Identitas"
      size="xl"
      :no-close-on-backdrop="addingIdentitas"
      :no-close-on-esc="addingIdentitas"
      :hide-header-close="addingIdentitas"
    >
      <b-form>
        <b-form-group label="Jenis Identitas" label-for="addJenis">
          <b-form-select
            id="addJenis"
            v-model="formAddIdentitas.jenisIdentitasId"
            :options="jenisIdentitas"
            placeholder="Pilih Identitas"
            required
          >
            <template #first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group label="No Identitas" label-for="addNo">
          <b-form-input
            id="addNo"
            v-model="formAddIdentitas.noIdentitas"
            required
            maxlength="32"
            placeholder="cth: 3201xxxxxxxxxxxx"
          />
        </b-form-group>

        <div class="wrap">
          <FotoPendukung :isNotShowCam="true" :isRemove="false" @showModalPreview="openModalPreview" :fotoPendukung="foto" :length="1" :minLength="1" />
          <div class="right">
            <label style="font-weight: bold">* Contoh pengambilan foto</label>
            <div class="foto-input-wrapper">
              <div class="foto-preview-wrapper-potrait">
                <img
                  src="../../../../public/img/Screenshot 2023-06-19 at 11.40.20.jpg"
                  alt="Contoh KTP"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- <b-alert variant="info" show v-if="addingIdentitas">
          Mengunggah foto & menyimpan data…
        </b-alert> -->
      </b-form>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()" :disabled="addingIdentitas">
          Cancel
        </b-button>
        <b-button variant="primary" @click="onAddIdentitas()" :disabled="addingIdentitas || !canSubmitAdd">
          {{ addingIdentitas ? 'Mengirim...' : 'Submit' }}
        </b-button>
      </template>
    </b-modal>

    <!-- ===== Modal Edit Identitas ===== -->
    <b-modal
      id="modal-identitas-edit"
      title="Edit Identitas"
      size="xl"
      :no-close-on-backdrop="savingEdit"
      :no-close-on-esc="savingEdit"
      :hide-header-close="savingEdit"
    >
      <b-form>
        <b-form-group label="Jenis Identitas" label-for="editJenis">
          <!-- <b-form-select
            id="editJenis"
            :placeholder="formEditIdentitas.jenisIdentitas"
            v-model="formEditIdentitas.identitasId"
            :options="jenisIdentitas"
            disabled
        /> -->
          <b-form-input id="editJenis" v-model="formEditIdentitas.jenisIdentitas" disabled />
        </b-form-group>

        <b-form-group label="No Identitas" label-for="editNo">
          <b-form-input
            id="editNo"
            v-model="formEditIdentitas.noIdentitas"
            required
            maxlength="32"
            placeholder="cth: 3201xxxxxxxxxxxx"
          />
        </b-form-group>

        <div class="wrap">
          <FotoPendukung :isNotShowCam="true" :isRemove="false" :isShowFoto="true" :fotoUrl="formEditIdentitas.fotoIdentitas" @openPreview="openPreview" @showModalPreview="openModalPreview" :fotoPendukung="fotoEdit" :length="1" :minLength="1" />
          <div class="right">
            <label style="font-weight: bold">* Contoh pengambilan foto</label>
            <div class="foto-input-wrapper">
              <div class="foto-preview-wrapper-potrait">
                <img
                  src="../../../../public/img/Screenshot 2023-06-19 at 11.40.20.jpg"
                  alt="Contoh KTP"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- <b-alert variant="info" show v-if="savingEdit" class="mt-3">
          Menyimpan perubahan & mengirim semua identitas…
        </b-alert> -->
      </b-form>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()" :disabled="savingEdit">
          Cancel
        </b-button>
        <b-button variant="primary" @click="onSaveEdit()" :disabled="savingEdit">
          {{ savingEdit ? 'Mengirim...' : 'Submit' }}
        </b-button>
      </template>
    </b-modal>

    <ModalPreview modalId="modal-preview-foto-f" :fotoPreview="activeFotoPreview" />

    <ModalIdentitas
      v-if="anggotaDetail && !idAnggota"
      :isModal="true"
      :idAnggota="anggotaDetail.id"
      :dataAnggota="anggotaDetail"
      :isEdit="true"
      titleInformasiEdit="Data identitas hanya bisa diubah melalui menu Master > Anggota."
    />
  </div>
</template>

<script>
import DataAnggota from "../../../components/anggota/DataAnggota";
import DataIdentitas from "../../../components/anggota/DataIdentitas";
import DataKerabat from "../../../components/anggota/DataKerabat";
import DataPihakLain from "../../../components/anggota/DataPihakLain";
import DataIdentitasDiri from "../../../components/anggota/DataIdentitasDiri";
import DataFoto from "../../../components/anggota/DataFoto";
import DataRekening from "../../../components/anggota/DataRekening.vue";
import FotoPendukung from "../../../components/webcam/FotoPendukung";
import ModalPreview from '../../../components/webcam/ModalPreview'
import ModalIdentitas from "../../gadai/ModalIdentitas";

import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "edit-anggota",
  components: {
    DataAnggota,
    DataIdentitas,
    DataKerabat,
    DataPihakLain,
    DataFoto,
    DataRekening,
    FotoPendukung,
    ModalPreview,
    DataIdentitasDiri,
    ModalIdentitas,
  },
  props: {
    isModal: { type: Boolean, default: false },
    idAnggota: { type: Number },
    requiredForDataKerabatAndPihakLain: { type: Boolean },
    getListAnggota: { type: Function },
    onToastSuccesEdit: { type: Function },
  },
  data() {
    return {
      id: null,
      initStatus: 0,
      isSubmitting: false,
      isLoadIdentitas: false,
      anggota: [],
      anggotaDetail: null,
      jenisIdentitasVal: [],
      activeFotoPreview:"",
      form: {
        id_kategori_fpp: null,
        name: null,
      },
      input: {
        dataIdentitas: {
          nasabahId: '',
          cabangId: '',
          nama: "",
          email: "Pugindo@gmail.com",
          jenisIdentitas: null,
          noIdentitas: "",
          jenisKelamin: null,
          statusKawin: null,
          kewarganegaraan: null,
          kotaLahir: "",
          tanggalLahir: "",
          kotaKtp: {},
          kecamatanKtp: null,
          kelurahanDesaKtp: null,
          rtKtp: "",
          rwKtp: "",
          alamatKtp: "",
          alamatKerja: "",
          telpKerja: "",
          pekerjaanBaru: null,
          listKecamatan: [],
          listKelurahan: [],
          kecLoading: false,
          kelLoading: false,
        },
        dataAnggota: {
          nasabahId: '',
          cabangId: '',
          pekerjaan: "",
          // teleponRumahSekarang: '',
          noHandphoneSekarang: "",
          // teleponKantorSekarang: '',
          kotaSekarang: {},
          kecamatanSekarang: null,
          kelurahanDesaSekarang: null,
          rtSekarang: "",
          rwSekarang: "",
          alamatSekarang: "",
          listKecamatan: [],
          listKelurahan: [],
          kecLoading: false,
          kelLoading: false,
          nomorGang: "",
          nomorRumah: "",
        },
        dataKerabat: {
          namaSuamiAtauIstri: "",
          namaAyah: "",
          namaIbu: "",
          noHandphoneSuamiIstri: "",
          noHandphoneAyah: "",
          noHandphoneIbu: "",
        },
        dataPihakLain: {
          namaPihakLain: "",
          hubunganPihakLain: "",
          // teleponRumahPihakLain: '',
          noHandphonePihakLain: "",
          // teleponKantorPihakLain: '',
          kotaPihakLain: {},
          kecamatanPihakLain: null,
          kelurahanDesaPihakLain: null,
          rtPihakLain: "",
          rwPihakLain: "",
          alamatPihakLain: "",
          listKecamatan: [],
          listKelurahan: [],
          kecLoading: false,
          kelLoading: false,
        },
        dataFoto: {
          fotoIdentitas: null,
          urlFotoIdentitas: null,
          fotoIdentitasBase64: null,
          activeFotoIdentitasBase64: null,
          fotoPendukung1: null,
          urlFotoPendukung1: null,
          fotoPendukung1Base64: null,
          activeFotoPendukung1Base64: null,
          fotoPendukung2: null,
          urlFotoPendukung2: null,
          fotoPendukung2Base64: null,
          activeFotoPendukung2Base64: null,
          fotoPendukung3: null,
          urlFotoPendukung3: null,
          fotoPendukung3Base64: null,
          activeFotoPendukung3Base64: null,
          fotoFormSurvey: null,
          urlFotoFormSurvey: null,
          fotoFormSurveyBase64: null,
          activeFotoFormSurveyBase64: null,
          fotoFormDataBpkb: null,
          urlFotoFormDataBpkb: null,
          fotoFormDataBpkbBase64: null,
          activeFotoFormDataBpkbBase64: null,
        },
      },
      jenisIdentitas: [],
      resetSection: null,
      newNasabahId: null,
      identitasList: [], // [{ id, nasabahId, jenisIdentitasId, noIdentitas, fotoIdentitas, _dirty }]
      savingAll: false,
      savingRowId: null,
      addingIdentitas: false,
      formAddIdentitas: {
        jenisIdentitasId: null,
        noIdentitas: "",
        file: null,
        preview: null,
      },
      foto: {
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
      },
      editingIndex: -1,
      savingEdit: false,
      formEditIdentitas: {
        id: null,
        nasabahId: null,
        identitasId: null,
        noIdentitas: "",
        fotoIdentitas: null,
        jenisIdentitasId: null,
      },
      fotoEdit: {
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
      },
      noAnggota: null,
    };
  },
  validations: {
    input: {
      dataKerabat: {
        namaAyah: { required },
        namaIbu: { required },
        noHandphoneAyah: { required },
        noHandphoneIbu: { required },
      },
      dataPihakLain: {
        namaPihakLain: { required },
        hubunganPihakLain: { required },
        noHandphonePihakLain: { required },
        kelurahanDesaPihakLain: { required },
        rtPihakLain: { required, minLength: minLength(3) },
        rwPihakLain: { required, minLength: minLength(3) },
        alamatPihakLain: { required },
      },
      dataModalAnggota: {},
    },
  },
  computed: {
    // agar :ok-disabled="!canSubmitAdd || addingIdentitas" berfungsi
    canSubmitAdd() {
      return (
        !!this.formAddIdentitas.jenisIdentitasId &&
        !!this.formAddIdentitas.noIdentitas &&
        !!this.newNasabahId
      );
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.input.dataKerabat[name];
      return $dirty ? !$error : null;
    },

    //----------------- Fungsi Inisialisasi -----------------
    init() {
      this.initStatus = 0;

      this.id = this.isModal ? this.idAnggota : this.$route.params.id;
      this.id = parseInt(this.id);

      const getJenisIdentitas = this.$axios
        .get("nasabah/jenis-identitas")
        .then((response) => {
          this.jenisIdentitas = [];
          for (const data of response.data) {
            this.jenisIdentitas.push({ value: data.id, text: data.name });
          }
        });

      const getSingleAnggota = this.$axios.get(`nasabah/${this.id}`).then((response) => {
        this.anggota = response.data;
        this.anggotaDetail = response.data;

        //----------------- Inisialisasi Data KTP -----------------
        this.input.dataIdentitas.nama = this.anggota.nama;
        this.input.dataIdentitas.email = this.anggota.email;
        // this.input.dataIdentitas.jenisIdentitas = this.anggota.identitas[0].jenisIdentitasId;
        // this.input.dataIdentitas.noIdentitas = this.anggota.identitas[0].noIdentitas;
        this.input.dataIdentitas.jenisKelamin =
          this.anggota.detail.jenisKelamin == null
            ? null
            : this.anggota.detail.jenisKelamin;
        this.input.dataIdentitas.statusKawin =
          this.anggota.detail.statusKawin == null
            ? null
            : this.anggota.detail.statusKawin;
        this.input.dataIdentitas.kewarganegaraan =
          this.anggota.detail.kewarganegaraan == null
            ? null
            : this.anggota.detail.kewarganegaraan;
        this.input.dataIdentitas.kotaLahir = this.anggota.detail.kotaLahir;
        this.input.dataIdentitas.alamatKerja =
          this.anggota.detail.alamatTempatKerja == null
            ? null
            : this.anggota.detail.alamatTempatKerja;
        this.input.dataIdentitas.telpKerja =
          this.anggota.detail.teleponTempatKerja == null
            ? null
            : this.anggota.detail.teleponTempatKerja;
        this.input.dataIdentitas.pekerjaanBaru =
          this.anggota.detail.pekerjaanBaru == null
            ? null
            : this.anggota.detail.pekerjaanBaru.id;
        this.input.dataIdentitas.statusKawin =
          this.anggota.detail.statusPerkawinan == null
            ? null
            : this.anggota.detail.statusPerkawinan;
        this.input.dataIdentitas.tanggalLahir = this.anggota.detail.tanggalLahir;
        this.input.dataIdentitas.kotaKtp = this.anggota.detail.kotaKtp;
        this.input.dataIdentitas.kecLoading = true;
        this.input.dataIdentitas.kelLoading = true;

        if (this.anggota.detail.kotaKtp.id != null) {
          this.$axios
            .get(`area/kecamatan/${this.anggota.detail.kotaKtp.id}`)
            .then((response) => {
              this.input.dataIdentitas.listKecamatan = response.data;
              this.input.dataIdentitas.kecamatanKtp = this.anggota.detail.kecamatanKtp.id;
              this.input.dataIdentitas.kecLoading = false;
              if (this.anggota.detail.kecamatanKtp.id != null) {
                this.$axios
                  .get(`area/kelurahan/${this.anggota.detail.kecamatanKtp.id}`)
                  .then((response) => {
                    this.input.dataIdentitas.listKelurahan = response.data;
                    this.input.dataIdentitas.kelurahanDesaKtp = this.anggota.detail.kelurahanDesaKtp.id;
                    this.input.dataIdentitas.kelLoading = false;
                  })
                  .catch((error) => {
                    console.log(error);
                    this.input.dataIdentitas.kelLoading = false;
                    this.input.dataIdentitas.loadKelFail = true;

                    this.$helper.parseError(this, error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
              this.input.dataIdentitas.kecLoading = false;
              this.input.dataIdentitas.loadKecFail = true;

              this.$helper.parseError(this, error);
            });
        }

        this.input.dataIdentitas.rtKtp = this.anggota.detail.rtKtp;
        this.input.dataIdentitas.rwKtp = this.anggota.detail.rwKtp;
        this.input.dataIdentitas.alamatKtp = this.anggota.detail.alamatKtp;
        this.input.dataIdentitas.nasabahId = this.anggota.id;
        this.input.dataIdentitas.cabangId = this.anggota.cabang ? this.anggota.cabang.id : '';

        //----------------- Inisialisasi Data Anggota Sekarang -----------------
        this.input.dataAnggota.pekerjaan = this.anggota.detail.pekerjaan;
        this.input.dataAnggota.noHandphoneSekarang = this.anggota.detail.noHandphoneSekarang;
        this.input.dataAnggota.kotaSekarang = this.anggota.detail.kotaSekarang;
        this.input.dataAnggota.kecLoading = true;
        this.input.dataAnggota.kelLoading = true;
        this.input.dataAnggota.nomorGang = this.anggota.detail.nomorGang;
        this.input.dataAnggota.nomorRumah = this.anggota.detail.nomorRumah;
        this.input.dataAnggota.nasabahId = this.anggota.id;
        this.input.dataAnggota.cabangId = this.anggota.cabang ? this.anggota.cabang.id : '';

        if (this.anggota.detail.kotaSekarang.id != null) {
          this.$axios
            .get(`area/kecamatan/${this.anggota.detail.kotaSekarang.id}`)
            .then((response) => {
              this.input.dataAnggota.listKecamatan = response.data;
              this.input.dataAnggota.kecamatanSekarang = this.anggota.detail.kecamatanSekarang.id;
              this.input.dataAnggota.kecLoading = false;
              if (this.anggota.detail.kecamatanSekarang.id != null) {
                this.$axios
                  .get(`area/kelurahan/${this.anggota.detail.kecamatanSekarang.id}`)
                  .then((response) => {
                    this.input.dataAnggota.listKelurahan = response.data;
                    this.input.dataAnggota.kelurahanDesaSekarang = this.anggota.detail.kelurahanDesaSekarang.id;
                    this.input.dataAnggota.kelLoading = false;
                  })
                  .catch((error) => {
                    this.input.dataAnggota.kelLoading = false;
                    this.input.dataAnggota.loadKelFail = true;

                    this.$helper.parseError(this, error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
              this.input.dataAnggota.kecLoading = false;
              this.input.dataAnggota.loadKecFail = true;

              this.$helper.parseError(this, error);
            });
        }

        this.input.dataAnggota.rtSekarang = this.anggota.detail.rtSekarang;
        this.input.dataAnggota.rwSekarang = this.anggota.detail.rwSekarang;
        this.input.dataAnggota.alamatSekarang = this.anggota.detail.alamatSekarang;

        //----------------- Inisialisasi Data Kerabat -----------------
        this.input.dataKerabat.namaSuamiAtauIstri = this.anggota.detail.namaSuamiAtauIstri;
        this.input.dataKerabat.namaAyah = this.anggota.detail.namaAyah;
        this.input.dataKerabat.namaIbu = this.anggota.detail.namaIbu;
        this.input.dataKerabat.noHandphoneSuamiIstri = this.anggota.detail.noHandphoneSuamiIstri;
        this.input.dataKerabat.noHandphoneAyah = this.anggota.detail.noHandphoneAyah;
        this.input.dataKerabat.noHandphoneIbu = this.anggota.detail.noHandphoneIbu;

        //----------------- Inisialisasi Data Pihak Lain -----------------
        this.input.dataPihakLain.namaPihakLain = this.anggota.detail.namaPihakLain;
        this.input.dataPihakLain.hubunganPihakLain = this.anggota.detail.hubunganPihakLain;
        this.input.dataPihakLain.noHandphonePihakLain = this.anggota.detail.noHandphonePihakLain;
        this.input.dataPihakLain.rtPihakLain = this.anggota.detail.rtPihakLain;
        this.input.dataPihakLain.rwPihakLain = this.anggota.detail.rwPihakLain;
        this.input.dataPihakLain.alamatPihakLain = this.anggota.detail.alamatPihakLain;
        this.input.dataPihakLain.kecLoading = true;
        this.input.dataPihakLain.kelLoading = true;

        if (this.anggota.detail.kotaPihakLain.id != null) {
          this.input.dataPihakLain.kotaPihakLain = this.anggota.detail.kotaPihakLain;

          this.$axios
            .get(`area/kecamatan/${this.anggota.detail.kotaPihakLain.id}`)
            .then((response) => {
              this.input.dataPihakLain.listKecamatan = response.data;
              this.input.dataPihakLain.kecamatanPihakLain = this.anggota.detail.kecamatanPihakLain.id;
              this.input.dataPihakLain.kecLoading = false;
              if (this.anggota.detail.kecamatanPihakLain.id != null) {
                this.$axios
                  .get(`area/kelurahan/${this.anggota.detail.kecamatanPihakLain.id}`)
                  .then((response) => {
                    this.input.dataPihakLain.listKelurahan = response.data;
                    this.input.dataPihakLain.kelurahanDesaPihakLain = this.anggota.detail.kelurahanDesaPihakLain.id;
                    this.input.dataPihakLain.kelLoading = false;
                  })
                  .catch((error) => {
                    console.log(error);
                    this.input.dataPihakLain.kelLoading = false;
                    this.input.dataPihakLain.loadKelFail = true;

                    this.$helper.parseError(this, error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
              this.input.dataPihakLain.kecLoading = false;
              this.input.dataPihakLain.loadKecFail = true;

              this.$helper.parseError(this, error);
            });
        }

        //----------------- Inisialisasi Data Foto -----------------
        this.input.dataFoto.urlFotoIdentitas = this.anggota.detail.fotoKtp;
        if (this.anggota.detail.fotoPendukung1 != null)
          this.input.dataFoto.urlFotoPendukung1 = this.anggota.detail.fotoPendukung1;
        if (this.anggota.detail.fotoPendukung2 != null)
          this.input.dataFoto.urlFotoPendukung2 = this.anggota.detail.fotoPendukung2;
        if (this.anggota.detail.fotoPendukung3 != null)
          this.input.dataFoto.urlFotoPendukung3 = this.anggota.detail.fotoPendukung3;
        if (this.anggota.detail.fotoFormSurvey != null)
          this.input.dataFoto.urlFotoFormSurvey = this.anggota.detail.fotoFormSurvey;
        if (this.anggota.detail.fotoFormDataBpkb != null)
          this.input.dataFoto.urlFotoFormDataBpkb = this.anggota.detail.fotoFormDataBpkb;

        this.input.dataFoto.activeFotoIdentitasBase64 = this.anggota.detail.fotoKtp;
        if (this.anggota.detail.fotoPendukung1 != null)
          this.input.dataFoto.activeFotoPendukung1Base64 = this.anggota.detail.fotoPendukung1;
        if (this.anggota.detail.fotoPendukung2 != null)
          this.input.dataFoto.activeFotoPendukung2Base64 = this.anggota.detail.fotoPendukung2;
        if (this.anggota.detail.fotoPendukung3 != null)
          this.input.dataFoto.activeFotoPendukung3Base64 = this.anggota.detail.fotoPendukung3;
        if (this.anggota.detail.fotoFormSurvey != null)
          this.input.dataFoto.activeFotoFormSurveyBase64 = this.anggota.detail.fotoFormSurvey;
        if (this.anggota.detail.fotoFormDataBpkb != null)
          this.input.dataFoto.activeFotoFormDataBpkbBase64 = this.anggota.detail.fotoFormDataBpkb;
      });

      Promise.all([getJenisIdentitas, getSingleAnggota])
        .then(() => {
          this.initStatus = 1;
        })
        .catch((error) => {
          console.log(error);
          this.initStatus = -1;
        });
    },

    //----------------- Fungsi Submit Data -----------------
    onSubmit() {
      const payload = new FormData();
      payload.append("id", this.id);

      //----------------- Append Data KTP -----------------
      payload.append("nama", this.input.dataIdentitas.nama);
      payload.append(
        "email",
        this.input.dataIdentitas.email != null
          ? this.input.dataIdentitas.email
          : "Pugindo@gmail.com"
      );
      //   payload.append("jenisIdentitasId", this.input.dataIdentitas.jenisIdentitas);
      //   payload.append("noIdentitas", this.input.dataIdentitas.noIdentitas);
      payload.append("cabangId", 1);
      payload.append("alamatKtp", this.input.dataIdentitas.alamatKtp);
      payload.append("kelurahanDesaKtp", this.input.dataIdentitas.kelurahanDesaKtp);
      payload.append("rtKtp", this.input.dataIdentitas.rtKtp);
      payload.append("rwKtp", this.input.dataIdentitas.rwKtp);
      payload.append("jenisKelamin", this.input.dataIdentitas.jenisKelamin);
      payload.append("statusPerkawinan", this.input.dataIdentitas.statusKawin);
      payload.append("kewarganegaraan", this.input.dataIdentitas.kewarganegaraan);
      payload.append("alamatTempatKerja", this.input.dataIdentitas.alamatKerja);
      payload.append("teleponTempatKerja", this.input.dataIdentitas.telpKerja);
      payload.append("pekerjaanBaru", this.input.dataIdentitas.pekerjaanBaru);

      //----------------- Append Data Anggota Sekarang -----------------
      payload.append("alamatSekarang", this.input.dataAnggota.alamatSekarang);
      payload.append(
        "kelurahanDesaSekarang",
        this.input.dataAnggota.kelurahanDesaSekarang
      );
      payload.append("rtSekarang", this.input.dataAnggota.rtSekarang);
      payload.append("rwSekarang", this.input.dataAnggota.rwSekarang);

      const kotaLahirId =
        (this.input.dataIdentitas.kotaLahir && this.input.dataIdentitas.kotaLahir.id) ||
        "";
      payload.append("kotaLahir", kotaLahirId);

      payload.append("tanggalLahir", this.input.dataIdentitas.tanggalLahir);
      payload.append("noHandphoneSekarang", this.input.dataAnggota.noHandphoneSekarang);
      payload.append("pekerjaan", this.input.dataAnggota.pekerjaan);
      payload.append("nomorGang", this.input.dataAnggota.nomorGang);
      payload.append("nomorRumah", this.input.dataAnggota.nomorRumah);

      //----------------- Append Data Kerabat -----------------
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaSuamiAtauIstri))
        payload.append("namaSuamiAtauIstri", this.input.dataKerabat.namaSuamiAtauIstri);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaAyah))
        payload.append("namaAyah", this.input.dataKerabat.namaAyah);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaIbu))
        payload.append("namaIbu", this.input.dataKerabat.namaIbu);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.noHandphoneSuamiIstri))
        payload.append(
          "noHandphoneSuamiIstri",
          this.input.dataKerabat.noHandphoneSuamiIstri
        );
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.noHandphoneAyah))
        payload.append("noHandphoneAyah", this.input.dataKerabat.noHandphoneAyah);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.noHandphoneIbu))
        payload.append("noHandphoneIbu", this.input.dataKerabat.noHandphoneIbu);

      //----------------- Append Data Pihak Lain -----------------
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.namaPihakLain))
        payload.append("namaPihakLain", this.input.dataPihakLain.namaPihakLain);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.hubunganPihakLain))
        payload.append("hubunganPihakLain", this.input.dataPihakLain.hubunganPihakLain);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.alamatPihakLain))
        payload.append("alamatPihakLain", this.input.dataPihakLain.alamatPihakLain);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.rtPihakLain))
        payload.append("rtPihakLain", this.input.dataPihakLain.rtPihakLain);
      if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.rwPihakLain))
        payload.append("rwPihakLain", this.input.dataPihakLain.rwPihakLain);
      if (
        this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.noHandphonePihakLain)
      )
        payload.append(
          "noHandphonePihakLain",
          this.input.dataPihakLain.noHandphonePihakLain
        );

      if (this.input.dataPihakLain.kelurahanDesaPihakLain != null) {
        payload.append(
          "kelurahanDesaPihakLain",
          this.input.dataPihakLain.kelurahanDesaPihakLain
        );
      }

      //----------------- Append Data Foto -----------------
      //   if (
      //     this.input.dataFoto.activeFotoIdentitasBase64 != null &&
      //     this.input.dataFoto.activeFotoIdentitasBase64 !=
      //       this.$baseFilePath + this.input.dataFoto.urlFotoIdentitas
      //   )
      //     payload.append("fotoIdentitas", this.input.dataFoto.activeFotoIdentitasBase64);

      if (
        this.input.dataFoto.activeFotoPendukung1Base64 != null &&
        this.input.dataFoto.activeFotoPendukung1Base64 !=
          this.$baseFilePath + this.input.dataFoto.urlFotoPendukung1
      )
        payload.append("fotoPendukung1", this.input.dataFoto.activeFotoPendukung1Base64);

      if (
        this.input.dataFoto.activeFotoPendukung2Base64 != null &&
        this.input.dataFoto.activeFotoPendukung2Base64 !=
          this.$baseFilePath + this.input.dataFoto.urlFotoPendukung2
      )
        payload.append("fotoPendukung2", this.input.dataFoto.activeFotoPendukung2Base64);

      if (
        this.input.dataFoto.activeFotoPendukung3Base64 != null &&
        this.input.dataFoto.activeFotoPendukung3Base64 !=
          this.$baseFilePath + this.input.dataFoto.urlFotoPendukung3
      )
        payload.append("fotoPendukung3", this.input.dataFoto.activeFotoPendukung3Base64);

      if (
        this.input.dataFoto.activeFotoFormSurveyBase64 != null &&
        this.input.dataFoto.activeFotoFormSurveyBase64 !=
          this.$baseFilePath + this.input.dataFoto.urlFotoFormSurvey
      )
        payload.append("fotoFormSurvey", this.input.dataFoto.activeFotoFormSurveyBase64);

      if (
        this.input.dataFoto.activeFotoFormDataBpkbBase64 != null &&
        this.input.dataFoto.activeFotoFormDataBpkbBase64 !=
          this.$baseFilePath + this.input.dataFoto.urlFotoFormDataBpkb
      )
        payload.append(
          "fotoFormDataBpkb",
          this.input.dataFoto.activeFotoFormDataBpkbBase64
        );

      //----------------- Submit Semua Data -----------------
      this.isSubmitting = true;

      this.$axios
        .post("nasabah/", payload, { timeout: 300000 })
        .then((response) => {
          if (this.isModal == true) {
            if (this.onToastSuccesEdit) {
              this.onToastSuccesEdit();
            } else {
              this.$helper.toastSucc(this, "Identitas berhasil diupdate");
            }

            this.dataModalAnggota = {
              idAnggota: response.data.id,
              noAnggota: response.data.noAnggota,
              //   noIdentitas: this.input.dataIdentitas.noIdentitas,
              nama: this.input.dataIdentitas.nama,
              email: this.input.dataIdentitas.email,
              noHp: this.input.dataAnggota.noHandphoneSekarang,
              noRumah: this.input.dataAnggota.teleponRumahSekarang,
              alamat: this.input.dataAnggota.alamatSekarang,
              isComplete: response.data.isComplete,
            };
            // this.$emit("updateModalAnggota", dataModalAnggota);
          } else {
            if (this.onToastSuccesEdit) {
              this.onToastSuccesEdit();
            } else {
              this.$helper.toastSucc(this, "Identitas berhasil diupdate");
            }
          }
          this.noAnggota = response.data.noAnggota;
          this.newNasabahId = response.data.id;

          if (this.getListAnggota) {
            this.getListAnggota(this.noAnggota);
          }
          this.fetchIdentitasList(response.data.noAnggota);
          this.$bvModal.hide("modal-confirm-edit");
          this.$bvModal.hide("modal-edit-anggota");

          if (!this.idAnggota) {
            this.init();
          }
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    //----------------- Fungsi Lain -----------------
    openModalConfirm(isBpkb) {
      if (isBpkb === true) {
        this.$v.input.$touch();

        if (this.$v.input.dataPihakLain.$anyError) {
          if (this.$v.input.dataPihakLain.namaPihakLain.$anyError) {
            this.$helper.toastErr(this, "Mohon isi Nama Pihak Lain terlebih dahulu!");
          }
          if (this.$v.input.dataPihakLain.hubunganPihakLain.$anyError) {
            this.$helper.toastErr(this, "Mohon isi Hubungan Pihak Lain terlebih dahulu!");
          }
          if (this.$v.input.dataPihakLain.noHandphonePihakLain.$anyError) {
            this.$helper.toastErr(this, "Mohon isi No. Hp Pihak Lain terlebih dahulu!");
          }
          if (this.$v.input.dataPihakLain.kelurahanDesaPihakLain.$anyError) {
            this.$helper.toastErr(
              this,
              "Mohon isi kelurahan pihak lain terlebih dahulu!"
            );
          }
          if (this.$v.input.dataPihakLain.rtPihakLain.$anyError) {
            this.$helper.toastErr(
              this,
              "Mohon isi RT pihak lain terlebih dahulu! dengan format 3 angka, contoh: 001"
            );
          }
          if (this.$v.input.dataPihakLain.rwPihakLain.$anyError) {
            this.$helper.toastErr(
              this,
              "Mohon isi RW pihak lain terlebih dahulu! dengan format 3 angka, contoh: 001"
            );
          }
          if (this.$v.input.dataPihakLain.alamatPihakLain.$anyError) {
            this.$helper.toastErr(this, "Mohon isi Alamat pihak lain terlebih dahulu!");
          }
          return;
        }

        if (!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kotaLahir)) {
          this.$helper.toastErr(this, "Mohon isi tempat lahir terlebih dahulu!");
        } else if (
          !this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kelurahanDesaKtp)
        ) {
          this.$helper.toastErr(
            this,
            "Mohon isi alamat sesuai ktp dengan lengkap terlebih dahulu!"
          );
        } else if (
          !this.$helper.isNotNullAndNotEmpty(this.input.dataAnggota.kelurahanDesaSekarang)
        ) {
          this.$helper.toastErr(
            this,
            "Mohon isi alamat domisili dengan lengkap terlebih dahulu!"
          );
          // }
          // // else if (this.input.dataFoto.activeFotoIdentitasBase64 == null) {
          // //   this.$helper.toastErr(this, "Tolong upload foto KTP anda");
        } else {
          this.$bvModal.show("modal-confirm-edit");
        }
      } else {
        if (!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kotaLahir)) {
          this.$helper.toastErr(this, "Mohon isi tempat lahir terlebih dahulu!");
        } else if (
          !this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kelurahanDesaKtp)
        ) {
          this.$helper.toastErr(
            this,
            "Mohon isi alamat sesuai ktp dengan lengkap terlebih dahulu!"
          );
        } else if (
          !this.$helper.isNotNullAndNotEmpty(this.input.dataAnggota.kelurahanDesaSekarang)
        ) {
          this.$helper.toastErr(
            this,
            "Mohon isi alamat domisili dengan lengkap terlebih dahulu!"
          );
          // } else if (this.input.dataFoto.activeFotoIdentitasBase64 == null) {
          //   this.$helper.toastErr(this, "Tolong upload foto KTP anda");
        } else {
          this.$bvModal.show("modal-confirm-edit");
        }
      }
    },

    onResetFields() {
      if (this.resetSection == 0) {
        this.input.dataIdentitas = {
          nama: "",
          email: "Pugindo@gmail.com",
          jenisIdentitas: null,
          noIdentitas: "",
          kotaLahir: "",
          tanggalLahir: "",
          kotaKtp: {},
          kecamatanKtp: null,
          kelurahanDesaKtp: null,
          rtKtp: "",
          rwKtp: "",
          alamatKtp: "",
          listKecamatan: [],
          listKelurahan: [],
          kecLoading: false,
          kelLoading: false,
        };
      } else if (this.resetSection == 1) {
        this.input.dataAnggota = {
          pekerjaan: "",
          teleponRumahSekarang: "",
          noHandphoneSekarang: "",
          teleponKantorSekarang: "",
          kotaSekarang: {},
          kecamatanSekarang: null,
          kelurahanDesaSekarang: null,
          rtSekarang: "",
          rwSekarang: "",
          alamatSekarang: "",
          listKecamatan: [],
          listKelurahan: [],
          kecLoading: false,
          kelLoading: false,
          nomorGang: "",
          nomorRumah: "",
        };
      } else if (this.resetSection == 2) {
        this.input.dataKerabat = {
          namaSuamiAtauIstri: "",
          namaAyah: "",
          namaIbu: "",
        };
      } else if (this.resetSection == 3) {
        this.input.dataPihakLain = {
          namaPihakLain: "",
          hubunganPihakLain: "",
          teleponRumahPihakLain: "",
          noHandphonePihakLain: "",
          teleponKantorPihakLain: "",
          kotaPihakLain: {},
          kecamatanPihakLain: null,
          kelurahanDesaPihakLain: null,
          rtPihakLain: "",
          rwPihakLain: "",
          alamatPihakLain: "",
          listKecamatan: [],
          listKelurahan: [],
          kecLoading: false,
          kelLoading: false,
        };
      }

      this.$bvModal.hide("modal-confirm-reset");
    },

    resetDataIdentitas() {
      this.resetSection = 0;
      this.$bvModal.show("modal-confirm-reset");
    },
    resetDataAnggota() {
      this.resetSection = 1;
      this.$bvModal.show("modal-confirm-reset");
    },
    resetDataKerabat() {
      this.resetSection = 2;
      this.$bvModal.show("modal-confirm-reset");
    },
    resetDataPihakLain() {
      this.resetSection = 3;
      this.$bvModal.show("modal-confirm-reset");
    },

    onCopyFields() {
      if (Object.keys(this.input.dataIdentitas.kotaKtp).length != 0) {
        this.input.dataAnggota.kotaSekarang = this.input.dataIdentitas.kotaKtp;
        this.input.dataAnggota.kecLoading = true;

        this.$axios
          .get(`area/kecamatan/${this.input.dataIdentitas.kotaKtp.id}`)
          .then((response) => {
            this.input.dataAnggota.listKecamatan = response.data;
            this.input.dataAnggota.kecLoading = false;
            this.input.dataAnggota.kelLoading = true;

            if (this.input.dataIdentitas.kecamatanKtp != null) {
              this.input.dataAnggota.kecamatanSekarang = this.input.dataIdentitas.kecamatanKtp;

              this.$axios
                .get(`area/kelurahan/${this.input.dataIdentitas.kecamatanKtp}`)
                .then((response) => {
                  this.input.dataAnggota.listKelurahan = response.data;
                  this.input.dataAnggota.kelLoading = false;

                  if (this.input.dataIdentitas.kelurahanDesaKtp != null) {
                    this.input.dataAnggota.kelurahanDesaSekarang = this.input.dataIdentitas.kelurahanDesaKtp;
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.input.dataAnggota.kelLoading = false;
                  this.input.dataAnggota.loadKelFail = true;
                  this.$helper.parseError(this, error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
            this.input.dataAnggota.kecLoading = false;
            this.input.dataAnggota.loadKecFail = true;

            this.$helper.parseError(this, error);
          });
      }

      if (this.input.dataIdentitas.rtKtp != "")
        this.input.dataAnggota.rtSekarang = this.input.dataIdentitas.rtKtp;
      if (this.input.dataIdentitas.rwKtp != "")
        this.input.dataAnggota.rwSekarang = this.input.dataIdentitas.rwKtp;
      if (this.input.dataIdentitas.alamatKtp != "")
        this.input.dataAnggota.alamatSekarang = this.input.dataIdentitas.alamatKtp;

      this.$bvModal.hide("modal-confirm-copy");
    },

    copyDataIdentitas() {
      this.$bvModal.show("modal-confirm-copy");
    },

    getEmail(email) {
      this.input.dataIdentitas.email = email;
    },

    // --------- (Opsional) Ambil list identitas dari server ---------
    async fetchIdentitasList(nasabahId) {
      this.isLoadIdentitas = true;
      const res = await this.$axios.get(
        `nasabah/get-nasabah-identitas?page=0&size=100&nasabahNo=${nasabahId}`
      );

      this.isLoadIdentitas = false;
      this.identitasList = res.data.content[0].identitas.map((x) => ({
        ...x,
        _dirty: false,
      }));

      // this.isLoadIdentitas = false
    },

    // --------- Tambah Identitas ----------
    onChangeAddPhoto(e) {
      const f = e.target.files && e.target.files[0];
      if (!f) return;
      this.formAddIdentitas.file = f;
      this.formAddIdentitas.preview = URL.createObjectURL(f);
    },

    async onAddIdentitas() {
      if (
        !this.foto.fotoBarangPendukung || 
        this.foto.fotoBarangPendukung.length === 0
      ) {
        this.$helper.toastErr(this, "Harap upload terlebih dahulu.");
        return;
      }

      if (!this.canSubmitAdd) return;
      try {
        this.addingIdentitas = true;

        const fileUpload = this.$helper.createSafeFileCopy(this.foto.fotoBarangPendukung);

        // 1) Ambil presigned url (seragamkan kemungkinan key)
        const presRes = await this.$axios.get("nasabah/create-identitas-presigned-url", {
          params: { contentType: "image",nasabahNo:this.noAnggota },
        });
        const d = presRes.data || {};
        const presignedUrl =
          d.url ||
          d.name ||
          d.presignedUrl ||
          d.presignedname ||
          d.data.url ||
          d.data.name;
        if (!presignedUrl) throw new Error("Gagal mendapatkan presigned URL");

        // 2) Upload ke storage
        await fetch(presignedUrl, {
          method: "PUT",
          headers: { "Content-Type": "image" },
          body: fileUpload, // dari komponen FotoPendukung
        });

        // 3) URL publik
        const publicUrl = presignedUrl.split("?")[0];

        // 4) simpan identitas (pakai body array sesuai backend terbaru)
        const payload = [
          {
            nasabahId: Number(this.newNasabahId),
            jenisIdentitasId: Number(this.formAddIdentitas.jenisIdentitasId),
            noIdentitas: String(this.formAddIdentitas.noIdentitas || "").trim(),
            fotoIdentitas: publicUrl,
          },
        ];

        const addRes = await this.$axios.post(
          "nasabah/create-nasabah-identitas",
          payload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        // 5) update tabel lokal
        const newId = addRes.data.id || "tmp-" + Date.now();
        this.identitasList.push({
          id: newId,
          nasabahId: this.newNasabahId,
          jenisIdentitasId: this.formAddIdentitas.jenisIdentitasId,
          noIdentitas: this.formAddIdentitas.noIdentitas,
          fotoIdentitas: publicUrl,
          _dirty: false,
        });

        this.fetchIdentitasList(this.noAnggota);
        if (this.getListAnggota) {
          this.getListAnggota(this.noAnggota);
        }
        this.$helper.toastSucc(this, "Identitas berhasil ditambahkan");
        this.formAddIdentitas = {
          jenisIdentitasId: null,
          noIdentitas: "",
          file: null,
          preview: null,
        };
        this.$bvModal.hide("modal-identitas-add");
        this.foto={
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
        }
      } catch (e) {
        const msg =
          e.response.data.message || e.response.data.reason || "Gagal menambah identitas";
        this.$helper.toastErr(this, msg);
      } finally {
        this.addingIdentitas = false;
      }
    },

    // --------- Ubah foto baris ----------
    editDataIdentitas(item) {
      this.editingIndex = this.identitasList.findIndex(function (x) {
        return x.identitasId === item.identitasId;
      });

      // Ambil jenisIdentitasId dengan fallback berantai tanpa ??
      var jenisId =
        item && item.identitasId != null
          ? item.identitasId
          : item && item.jenis_identitas_id != null
          ? item.jenis_identitas_id
          : item && item.jenisIdentitas && item.jenisIdentitas.id != null
          ? item.jenisIdentitas.id
          : null;

      // noIdentitas fallback
      var noIdentitas =
        item && item.noIdentitas != null && item.noIdentitas !== ""
          ? item.noIdentitas
          : item && item.no_identitas != null
          ? item.no_identitas
          : "";

      // fotoIdentitas fallback
      var fotoIdentitas =
        item && item.fotoIdentitas != null
          ? item.fotoIdentitas
          : item && item.foto_identitas != null
          ? item.foto_identitas
          : null;

      // nasabahId fallback
      var nasabahId = item && item.nasabahId != null ? item.nasabahId : this.newNasabahId;

      this.formEditIdentitas = {
        id: item.identitasId,
        nasabahId: nasabahId,
        identitasId: jenisId,
        noIdentitas: noIdentitas,
        fotoIdentitas: fotoIdentitas,
        jenisIdentitas: item.jenisIdentitas,
        jenisIdentitasId: item.jenisIdentitasId,
      };
      
      this.fotoEdit={
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
      }

      // Seed untuk FotoPendukung (array 1 elemen)
      //   this.fotoEdit = fotoIdentitas ? [fotoIdentitas] : [];

      this.$bvModal.show("modal-identitas-edit");
    },
    // === Simpan perubahan satu baris, lalu KIRIM SEMUA LIST
    async onSaveEdit() {
      try {
        this.savingEdit = true;
        if (this.fotoEdit.fotoBarangPendukung) {
        const fileUpload = this.$helper.createSafeFileCopy(this.fotoEdit.fotoBarangPendukung);
          
        const presRes = await this.$axios.get("nasabah/create-identitas-presigned-url", {
          params: { contentType: "image",nasabahNo:this.noAnggota },
        });
        const d = presRes.data || {};
        const presignedUrl =
          d.url ||
          d.name ||
          d.presignedUrl ||
          d.presignedname ||
          d.data.url ||
          d.data.name;
        if (!presignedUrl) throw new Error("Gagal mendapatkan presigned URL");

        // 2) Upload ke storage
        await fetch(presignedUrl, {
          method: "PUT",
          headers: { "Content-Type": "image" },
          body: fileUpload, // dari komponen FotoPendukung
        });

        // 3) URL publik
        const publicUrl = presignedUrl.split("?")[0];

        const updated = {
          id: this.formEditIdentitas.identitasId,
          noIdentitas: this.formEditIdentitas.noIdentitas,
          fotoIdentitas: publicUrl,
          nasabahId: this.formEditIdentitas.nasabahId,

          jenisIdentitasId: this.formEditIdentitas.jenisIdentitasId,
          // jenisIdentitasId : this.formEditIdentitas.jenisIdentitas == "KTP" ? 1 : this.formEditIdentitas.jenisIdentitas == "SIM" ? 2 : 3,
        };

        // Kirim SELURUH daftar (berubah & tidak)
        // const payload = this.buildUpdatePayload(this.identitasList, this.newNasabahId);

        const res = await this.$axios.put(
          `nasabah/update-nasabah-identitas/${this.formEditIdentitas.identitasId}`,
          updated
        );

        this.$helper.toastSucc(this, "Identitas berhasil diupdate");
        this.fetchIdentitasList(this.noAnggota);
        this.$bvModal.hide("modal-identitas-edit");
        }else{
            const updated = {
          id: this.formEditIdentitas.identitasId,
          noIdentitas: this.formEditIdentitas.noIdentitas,
          fotoIdentitas: this.formEditIdentitas.fotoIdentitas,
          nasabahId: this.formEditIdentitas.nasabahId,

          jenisIdentitasId: this.formEditIdentitas.jenisIdentitasId,
          // jenisIdentitasId : this.formEditIdentitas.jenisIdentitas == "KTP" ? 1 : this.formEditIdentitas.jenisIdentitas == "SIM" ? 2 : 3,
        };

        // Kirim SELURUH daftar (berubah & tidak)
        // const payload = this.buildUpdatePayload(this.identitasList, this.newNasabahId);

        const res = await this.$axios.put(
          `nasabah/update-nasabah-identitas/${this.formEditIdentitas.identitasId}`,
          updated
        );

        this.$helper.toastSucc(this, "Identitas berhasil diupdate");
        this.fetchIdentitasList(this.noAnggota);
        if (this.getListAnggota) {
          this.getListAnggota(this.noAnggota);
        }
        this.$bvModal.hide("modal-identitas-edit");
        }

        this.fotoEdit={
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
        }
        // this.$bvToast.toast('Identitas berhasil diperbarui.', { variant: 'success', solid: true });

        // Optional (kalau mau hard refresh dari server)
        // await this.getIdentitasList();
      } catch (err) {
        // const msg =
        //   err.response.data.message || err.message || "Gagal menambah identitas";
        // this.$helper.toastErr(this, msg);
        this.$helper.toastErr(
          this,
          err.response.data.message ||
            err.response.data.reason ||
            "Gagal menyimpan identitas."
        );
        this.fetchIdentitasList(this.noAnggota);
        // const msg = err?.response?.data?.message || 'Gagal menyimpan identitas.'
        // this.$bvToast.toast(msg, { variant: 'danger', solid: true });
      } finally {
        this.savingEdit = false;
      }
    },
    onCloseIdentitas() {
        const datas = { ...this.dataModalAnggota, identitas: this.identitasList };
        this.$bvModal.hide("modal-confirm-edit");
        this.$emit("updateModalAnggota", datas);
        if(!this.isModal){
            let path = this.$route.path.split('/')
            path.pop()
            path = path.join("/") + `/${this.dataModalAnggota.idAnggota}`
            this.$router.push({ path })
        }
    },

    openPreview(foto) {
      this.activeFotoPreview = foto;
      this.$bvModal.show("modal-preview-foto-f");
    },
    openModalPreview(){
        this.activeFotoPreview = this.fotoEdit.activeFotoPendukungBase64 || this.foto.activeFotoPendukungBase64
        this.$bvModal.show("modal-preview-foto-f")
     },

    // === Susun payload yang diharapkan API
    buildUpdatePayload(list, nasabahIdFallback) {
      var arr = Array.isArray(list) ? list : [];
      return arr.map(function (x) {
        var jId =
          x && x.identitasId != null
            ? x.identitasId
            : x && x.jenis_identitas_id != null
            ? x.jenis_identitas_id
            : x && x.jenisIdentitas && x.jenisIdentitas.id != null
            ? x.jenisIdentitas.id
            : null;

        var noId =
          x && x.noIdentitas != null && x.noIdentitas !== ""
            ? x.noIdentitas
            : x && x.no_identitas != null
            ? x.no_identitas
            : "";

        var foto =
          x && x.fotoIdentitas != null
            ? x.fotoIdentitas
            : x && x.foto_identitas != null
            ? x.foto_identitas
            : null;

        var jenis =
          x && x.jenisIdentitas != null
            ? x.jenisIdentitas
            : x && x.jenis_identitas != null
            ? x.jenis_identitas
            : null;

        return {
          nasabahId: x && x.nasabahId != null ? x.nasabahId : nasabahIdFallback,
          id: jId,
          jenisIdentitasId: jenis == "KTP" ? 1 : jenis == "SIM" ? 2 : 3,
          noIdentitas: noId,
          fotoIdentitas: foto,
        };
      });
    },

    getIdByName(list, name) {
      return;
      list.find((i) => i.name.toLowerCase().trim() === String(name).toLowerCase().trim())
        .id;
    },
  },

  watch: {
    //----------------- Pantau Data Identitas -----------------
    "input.dataIdentitas.kotaKtp": function (x) {
      if (x.id != undefined) {
        this.input.dataIdentitas.kecLoading = true;
        this.input.dataIdentitas.kecamatanKtp = null;
        this.input.dataIdentitas.listKecamatan = [];
        this.input.dataIdentitas.kelurahanDesaKtp = null;
        this.input.dataIdentitas.listKelurahan = [];
        this.$axios
          .get(`area/kecamatan/${x.id}`)
          .then((response) => {
            this.input.dataIdentitas.listKecamatan = response.data;
            this.input.dataIdentitas.kecLoading = false;
          })
          .catch((error) => {
            this.input.dataIdentitas.kecLoading = false;
            this.input.dataIdentitas.loadKecFail = true;

            this.$helper.parseError(this, error);
          });
      }
    },

    "input.dataIdentitas.kecamatanKtp": function (id) {
      if (id != null) {
        this.input.dataIdentitas.kelLoading = true;
        this.input.dataIdentitas.listKelurahan = [];
        this.input.dataIdentitas.kelurahanDesaKtp = null;
        this.$axios
          .get(`area/kelurahan/${id}`)
          .then((response) => {
            this.input.dataIdentitas.listKelurahan = response.data;
            this.input.dataIdentitas.kelLoading = false;
          })
          .catch((error) => {
            this.input.dataIdentitas.kelLoading = false;
            this.input.dataIdentitas.loadKelFail = true;

            this.$helper.parseError(this, error);
          });
      }
    },

    //----------------- Pantau Data Anggota Sekarang -----------------
    "input.dataAnggota.kotaSekarang": function (x) {
      if (x.id != undefined) {
        this.input.dataAnggota.kecLoading = true;
        this.input.dataAnggota.kecamatanSekarang = null;
        this.input.dataAnggota.listKecamatan = [];
        this.input.dataAnggota.kelurahanDesaSekarang = null;
        this.input.dataAnggota.listKelurahan = [];
        this.$axios
          .get(`area/kecamatan/${x.id}`)
          .then((response) => {
            this.input.dataAnggota.listKecamatan = response.data;
            this.input.dataAnggota.kecLoading = false;
          })
          .catch((error) => {
            this.input.dataAnggota.kecLoading = false;
            this.input.dataAnggota.loadKecFail = true;

            this.$helper.parseError(this, error);
          });
      }
    },

    "input.dataAnggota.kecamatanSekarang": function (id) {
      if (id != null) {
        this.input.dataAnggota.kelLoading = true;
        this.input.dataAnggota.listKelurahan = [];
        this.input.dataAnggota.kelurahanDesaSekarang = null;
        this.$axios
          .get(`area/kelurahan/${id}`)
          .then((response) => {
            this.input.dataAnggota.listKelurahan = response.data;
            this.input.dataAnggota.kelLoading = false;
          })
          .catch((error) => {
            this.input.dataAnggota.kelLoading = false;
            this.input.dataAnggota.loadKelFail = true;

            this.$helper.parseError(this, error);
          });
      }
    },

    //----------------- Pantau Data Pihak Lain -----------------
    "input.dataPihakLain.kotaPihakLain": function (x) {
      if (x.id != undefined) {
        this.input.dataPihakLain.kecLoading = true;
        this.input.dataPihakLain.kecamatanPihakLain = null;
        this.input.dataPihakLain.listKecamatan = [];
        this.input.dataPihakLain.kelurahanDesaPihakLain = null;
        this.input.dataPihakLain.listKelurahan = [];
        this.$axios
          .get(`area/kecamatan/${x.id}`)
          .then((response) => {
            this.input.dataPihakLain.listKecamatan = response.data;
            this.input.dataPihakLain.kecLoading = false;
          })
          .catch((error) => {
            this.input.dataPihakLain.kecLoading = false;
            this.input.dataPihakLain.loadKecFail = true;

            this.$helper.parseError(this, error);
          });
      }
    },

    "input.dataPihakLain.kecamatanPihakLain": function (id) {
      if (id != null) {
        this.input.dataPihakLain.kelLoading = true;
        this.input.dataPihakLain.listKelurahan = [];
        this.input.dataPihakLain.kelurahanDesaPihakLain = null;
        this.$axios
          .get(`area/kelurahan/${id}`)
          .then((response) => {
            this.input.dataPihakLain.listKelurahan = response.data;
            this.input.dataPihakLain.kelLoading = false;
          })
          .catch((error) => {
            this.input.dataPihakLain.kelLoading = false;
            this.input.dataPihakLain.loadKelFail = true;

            this.$helper.parseError(this, error);
          });
      }
    },
  },

  created() {
    this.init();
    // this.getJenisIdentitas()
  },
};
</script>

<style scoped>
.wrap {
  display: flex;
  flex-direction: column; /* mobile: atas-bawah */
  gap: 1.5rem;
}
.right img {
  max-width: 100%;
  height: auto;
  display: block;
}
@media (min-width: 1024px) {
  /* laptop ke atas */
  .wrap {
    flex-direction: row;
    align-items: flex-start;
  }
  .right {
    margin-left: 2.5rem;
    width: 50%;
  }
  .wrap > :first-child {
    width: 50%;
  }
}
</style>
